/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

// @deprecated
export const renderTimeout = (length: number = 1, ...args: number[]): number => {
  let timeout = 9.5 * length;
  args.length && args.forEach(n => {
    timeout += n;
  });
  return timeout;
};

/**
 * Provides a utility which allows for automatically scrolling to the given element
 * within the Global Group Chooser.
 *
 * If the number of top-level sub-accounts is greater than or equal to 100, we defer
 * scrolling to the selected group until the current process has completed, then delay
 * the scroll for approx 1.5 seconds (which is adequate for each of the test cases).
 * Likewise, when the total number of top-level sub-accounts is less than 100, we defer
 * scrolling for 1.5 seconds. This is necessary in order to ensure the complete list
 * has been painted to the DOM prior to auto-scrolling, otherwise, the element will
 * only be partially scrolled to (as the list elements will continue to be rendered).
 */
export const scrollToGroup = (element, children) => {
  if (children >= 100 && window.requestIdleCallback) {
    const id = window.requestIdleCallback(() => {
      cancelIdleCallback(id);
      autoscroll(element);
    });
  } else {
    autoscroll(element);
  }
};

/**
 * Performs a delayed auto-scroll of the given element. The delay is necessary
 * to ensure the entire list has been painted to the DOM.
 */
const autoscroll = (element: HTMLElement, delay = 1500) => {
  setTimeout(() => {
    element.scrollIntoView({behavior: 'smooth'});
  }, delay);
};
